import { EnhancedAssumptions, VisibleScenarios } from '../types';

export const INITIAL_ASSUMPTIONS: EnhancedAssumptions = {
  propertyValueScenario: 'current_estimate',
  propertyValue: 2161000, // Zillow Zestimate (Dec 2025)
  monthlyRentScenario: 'zillow_estimate',
  monthlyRent: 6980, // Zillow Rent Zestimate (Dec 2025)
  originalPurchasePrice: 52000, // Historical purchase price (1970s)
  currentAssessedValue: 147000, // Prop 13 protected assessed value
  propertyAppreciationScenario: 'historical_la',
  propertyAppreciation: 3.5,
  rentGrowthScenario: 'modest',
  rentGrowth: 1.0,
  stockReturnsScenario: 'historical_longterm',
  stockReturns: 7.5,
  bondReturnsScenario: 'current',
  bondReturns: 1.5,
  inflationRate: 2.5,
  includeInflation: true,
  propertyTaxScenario: 'typical',
  propertyTaxRate: 1.1, // ~1% base + local assessments in Orange County
  insuranceCostScenario: 'coastal_ca',
  insuranceCost: 7000,
  maintenanceScenario: 'well_maintained',
  maintenanceRate: 0.5,
  vacancyScenario: 'good',
  vacancyRate: 5.0,
  managementScenario: 'standard',
  managementFee: 8.0,
  sellingCostsScenario: 'typical',
  sellingCosts: 6.0,
  rentalSetupCostsScenario: 'standard',
  rentalSetupCosts: 15000, // Initial setup costs for rental
  rentalIncomeTaxRate: 30.0,
  capitalGainsRate: 25.0, // Federal + CA + NIIT
  depreciation: true,
  rentalIncomeStrategy: 'invest', // 'invest' or 'spend'
  showHalfOwnership: false
};

export const INITIAL_VISIBLE_SCENARIOS: VisibleScenarios = {
  rent: true,
  sell100: false,
  sell80_20: true,
  sell60_40: false
};